// @ts-nocheck
import React from "react";
// @ts-ignore
import Carousel from "react-bootstrap/Carousel";
import Banner1 from "../../assets/videos/mountains.mp4";
import Banner2 from "../../assets/videos/shore.mp4";
// @ts-ignore
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import Banner4 from "../../assets/videos/sunset.mp4";
import "./BannerStyles.css";
// @ts-ignore
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// @ts-ignore
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";

export default function Banner() {
  return (
    <Carousel
      slide="false"
      fade="true"
      className="BannerCarousel"
    >
      <Carousel.Item interval={3000}>
        <video
          src={Banner1}
          autoPlay loop muted
          className="BannerImg"
        />
        <Carousel.Caption>
          <h3>Carbon Neutral</h3>
          <p>Leading India's stride to reduce Emissions</p>
          <Button
            as={Link}
            to="/buyers"
            className="BannerBtn "
            variant="outline-light"
          >
            <b>Learn More </b>
            <FontAwesomeIcon
              className="BannerBtnIcon"
              icon={icon({ name: "arrow-right" })}
            />
          </Button>
          <div className="mouse-down center">
            <div className="bullet"></div>
          </div>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={2000}>
        <video
          src={Banner2}
          autoPlay loop muted
          className="BannerImg w-100 h-100"
        />
        <Carousel.Caption>
          <h3>Our Planet</h3>
          <p>Caring and Giving Back to Mother Nature</p>
          <Button
            as={Link}
            to="/impact"
            className="BannerBtn "
            variant="outline-light"
          >
            <b>Learn More </b>
            <FontAwesomeIcon
              className="BannerBtnIcon"
              icon={icon({ name: "arrow-right" })}
            />
          </Button>
          <div className="mouse-down center">
            <div className="bullet"></div>
          </div>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={2000}>
        <video
          src={Banner4}
          autoPlay loop muted
          className="BannerImg"
        />
        <Carousel.Caption>
          <h3>Climate Protection </h3>
          <p>Eco-friendly Energy Solutions</p>
          <Button
            as={Link}
            to="/projects"
            className="BannerBtn"
            variant="outline-light"
          >
            <b>Learn More </b>
            <FontAwesomeIcon
              className="BannerBtnIcon"
              icon={icon({ name: "arrow-right" })}
            />
          </Button>
          <div className="mouse-down center">
            <div className="bullet"></div>
          </div>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}
